import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters} from "@signals";
import {BACKEND_APIS, GROUPED_BY} from "@constants";
import { elementsInLoading } from "../../@signals";


export default function useSkuDetailsDistributionData() {
	const { showToast } = useAppToast()

	const tabs = useSignal({})
	const distributionData = useSignal({})
    const isLoadingDistribution = useSignal(false)

	const tabSelected = useSignal(GROUPED_BY.COUNTRY)

    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			distributionData.value = {}
            isLoadingDistribution.value = true
			postSubmit(`${BACKEND_APIS.SKU_DETAILS}/distribution`, { ...commonFiltersValue.value }).then(res => {
				tabs.value = res.tabs
				distributionData.value = res.data
			}).catch(() => showToast.error()
			).finally(() => {
                isLoadingDistribution.value = false
			})
		})
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoadingDistribution.value)
			elementsInLoading.value = [...elementsInLoading.value, 'distribution']
		else{
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'distribution')
		}
	}, [isLoadingDistribution.value])

	const handleChangeTabSelected = (_, newValue) => {
		tabSelected.value = newValue
	}


	return {
		distributionData: distributionData.value,
		tabs: tabs.value,
		tabSelected: tabSelected.value,
        isLoadingDistribution: isLoadingDistribution.value,
		handleChangeTabSelected
	}
}